import { Button, ButtonProps, Tooltip } from "antd";
import { useTranslate } from "#src/hooks";
import { UppercaseIcon } from "components/icons/";
import { useAntTheme } from "hooks/useAntTheme/";

interface TextUppercaseSettingsProps extends Omit<
  ButtonProps,
  "value" | "onChange"
> {
  value?: boolean;
  onChange: (value: boolean) => void;
}

export const TextUppercaseSettings = ({
  value,
  onChange,
  ...buttonProps
}: TextUppercaseSettingsProps) => {
  const t = useTranslate();
  const { theme } = useAntTheme();
  return (
    <Tooltip title={t("components.templates.settings.uppercase")}>
      <Button
        type="text"
        onClick={() => {
          if (value) {
            onChange(false);
          } else {
            onChange(true);
          }
        }}
        icon={<UppercaseIcon />}
        style={{
          backgroundColor: value ? theme.colorLightGrey : undefined,
        }}
        {...buttonProps}
      />
    </Tooltip>
  );
};
